module.exports = __webpack_public_path__ + "img/goods10_5.86ea68ee.jpg";